import React from "react";
import { Card } from "react-bootstrap";
import { FaRegCopy } from "react-icons/fa";

const FormDetails = ({ selected }) => {
  return (
    <>
      <div className="w-50 m-auto mt-3">
        <div className="border bg-light rounded-1 mb-3 p-3 shadow-sm">
          <div className="details-header">
            <h5>{selected.name}</h5>

            <span className={`status-badge ${selected.status.toLowerCase()}`}>
              {selected.status}
            </span>
          </div>

          <div className="details-row">
            <span>Created At</span>
            <strong>{selected.createdAt}</strong>
          </div>

          <div className="details-row">
            <span>Last Updated</span>
            <strong>{selected.updatedAt}</strong>
          </div>

          <div className="details-row">
            <span>Form URL</span>
            <div className="hstack gap-2">
              <a href={selected.url} target="_blank" rel="noreferrer">
                {selected.url}
              </a>
              <FaRegCopy
                className="text-primary"
                title="Copy Url"
                style={{ cursor: "pointer" }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FormDetails;
